import styled from 'styled-components'

export const ContainerSearch = styled.div`
  margin-top: 1.25rem;
`
